"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created by inf011 on 15/08/2016.
 */

var mobx_1 = require("mobx");

var DialState =
/** @class */
function () {
  function DialState() {
    var _this = this;

    this.dialogs = [];

    this.close = function () {
      _this.dialogs.pop();
    };

    this.messageBox = function (parms) {
      return new Promise(function (resolve) {
        var pars = parms || {};
        var dialog = {
          style: pars.style,
          title: pars.title || DialState.defaultParams.title,
          message: pars.message || DialState.defaultParams.message,
          buttons: DialState.dialogButtons(pars.buttons, pars.default, pars.variantButtons),
          respon: function respon(button) {
            resolve(button);

            _this.close();
          }
        };

        _this.dialogs.push(dialog);
      });
    };
  }

  DialState.dialogButton = function (button, defaultButton, variantButtons) {
    if (!button) {
      return DialState.dialogButton(DialState.defaultParams.buttons[0]);
    }

    if (typeof button === 'string') {
      return {
        label: button,
        primary: button === defaultButton,
        variant: variantButtons,
        default: button === defaultButton
      };
    }

    return __assign({
      primary: !button.secondary,
      default: button.label === defaultButton
    }, button);
  };

  DialState.dialogButtons = function (buttons, defaultButton, variantButtons) {
    if (!buttons) {
      return [DialState.dialogButton()];
    }

    return buttons.map(function (button) {
      return DialState.dialogButton(button, defaultButton, variantButtons);
    });
  };

  DialState.defaultParams = {
    title: 'Alerta',
    message: 'Missatge',
    buttons: ['Acceptar']
  };

  __decorate([mobx_1.observable], DialState.prototype, "dialogs", void 0);

  __decorate([mobx_1.action], DialState.prototype, "close", void 0);

  return DialState;
}();

exports.default = DialState;